export default __webpack_public_path__ + "bfe3fe5347f1953c4543895c7e43d61c.png";